import {changeValue} from '@github-ui/form-utils'
import {on} from 'delegated-events'

// Show the mark all dropdown when the "Select all..." text is clicked
on('click', '.js-failed-invitations-mark-all', function () {
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  document.querySelector<HTMLInputElement>('.js-failed-invitations-mark-all')!.hidden = true
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  document.querySelector<HTMLInputElement>('.js-failed-invitations-unmark-all')!.hidden = false
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  changeValue(document.querySelector<HTMLInputElement>('.js-failed-invitations-mark-all-checkbox')!, true)
  hideSelectedInvitationButtons(true)
  hideAllInvitationButtons(false)
  updateSelectedInvitationLabel()
})

// Clear the selection when the "Clear selection" text is clicked
on('click', '.js-failed-invitations-unmark-all', function () {
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  document.querySelector<HTMLInputElement>('.js-failed-invitations-mark-all')!.hidden = true
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  document.querySelector<HTMLInputElement>('.js-failed-invitations-unmark-all')!.hidden = true
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  changeValue(document.querySelector<HTMLInputElement>('.js-failed-invitations-mark-all-checkbox')!, false)
  hideAllInvitationButtons(true)
  hideSelectedInvitationButtons(false)
})

// Whether to hide the "All invitations" buttons
function hideAllInvitationButtons(showAllButtons: boolean) {
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  document.getElementById('retry_all_invitations_button')!.hidden = showAllButtons
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  document.getElementById('delete_all_invitations_button')!.hidden = showAllButtons
}

// Whether to hide the "Selected invitations" buttons
function hideSelectedInvitationButtons(showInvitationButtons: boolean) {
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  document.getElementById('retry_selected_invitations_button')!.hidden = showInvitationButtons
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  document.getElementById('delete_selected_invitations_button')!.hidden = showInvitationButtons
}

function updateSelectedInvitationLabel() {
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const failedInvitationCount = document.getElementById('total-failed-invitation-count')!.getAttribute('value') || ''
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const currentInvitationElement = Array.from(document.getElementsByClassName('Button-label')).find(element => {
    return element.textContent?.includes('selected')
  })!
  const currentInvitationCount = currentInvitationElement.textContent || ''
  currentInvitationElement.textContent = currentInvitationCount.replace(/\d+/g, failedInvitationCount)
}
